import React from 'react'
import { styled } from '@mui/material/styles'
import { bannerSx, cardSx, classToFComponent, FCClassContext } from 'src/utils/views'

import Alert from '@mui/material/Alert'
import Paper from '@mui/material/Paper'
import Tooltip from '@mui/material/Tooltip'

import TcmProgress from '../../the-consumer-market/views/helpers/tcm_progress'
import { KpiScope } from '../ad_scopes'

export function LoadError({ message }: { message: string }) {
    if (!message) return null
    return (
        <Alert severity="error" sx={{ ...bannerSx('danger'), flexShrink: 0 }}>
            {message}
        </Alert>
    )
}

export function Aviso({ message }: { message: string }) {
    if (!message) return null
    return (
        <Alert severity="info" sx={{ ...bannerSx('blue'), flexShrink: 0 }}>
            {message}
        </Alert>
    )
}

// ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
// :: Cartão (mesmo visual dos cartões do Mercado IA, com o número já formatado)
// ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

const Tile = styled(Paper)({
    ...cardSx,
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '13px 12px',
    minWidth: 0
})

const TileValue = styled('span')({
    fontSize: 'clamp(18px, 1.5vw, 26px)',
    lineHeight: 1,
    fontWeight: 800,
    color: 'var(--ink)',
    marginBottom: 6,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
})

const TileLabel = styled('span')({
    fontSize: 11.5,
    lineHeight: 1.25,
    color: 'var(--muted)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
})

type KpiViewProps = {
    className?: string
    scope: KpiScope
}

class KpiViewClass implements FCClassContext<KpiViewProps> {
    render({ className, scope }: KpiViewProps) {
        return (
            <Tile elevation={0} className={className}>
                {!scope.loaded && <TcmProgress />}
                {scope.loaded && (
                    <>
                        <Tooltip title={scope.detalhe}>
                            <TileValue>{scope.texto}</TileValue>
                        </Tooltip>
                        <TileLabel title={scope.hint || scope.caption}>{scope.caption}</TileLabel>
                    </>
                )}
            </Tile>
        )
    }
}

export const KpiView = classToFComponent(KpiViewClass, React)
